import axios from "axios";
import {
  deepSerializeDatesForApi,
  shouldSerializeDataAsJson,
  shouldSerializeParamsObject,
} from "./serializeRequestDates";

const attachDateSerialization = (client) => {
  client.interceptors.request.use((config) => {
    if (shouldSerializeDataAsJson(config.data)) {
      config.data = deepSerializeDatesForApi(config.data);
    }
    if (shouldSerializeParamsObject(config.params)) {
      config.params = deepSerializeDatesForApi(config.params);
    }
    return config;
  });
};

export const axiosProtected = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // timeout: 30000, // 30 seconds timeout
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
attachDateSerialization(axiosProtected);

const axiosDefault = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // timeout: 30000, // 30 seconds timeout
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
attachDateSerialization(axiosDefault);

export default axiosDefault;
